import React, { useContext, useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import { connect } from "react-redux";
import Modal from "modules/common/components/Modal";
import useFormValidator from "useFormValidator";
import withForm from 'modules/common/hoc/withForm';
import { ModalContext } from "App";
import { customStyle, omitEmptyArgs } from "helper";
import Select from "react-select";
import PropTypes from "prop-types";
import * as actions from "../action";
import * as c from "../constant";

function AssessmentLevelsModal({
  createData,
  type,
  dataInfo,
  updateData,
  getList,
  showData,
  landClassificationsList,
  getLandClassificationsList,
  history,
  getOrdinanceRevisionList,
  ordinanceRevisionList,
  ordinanceRevisionId
}) {

  const [formData, setFormData] = useState({
    assessment_level: '',
    rptax_land_classification_id: '',
    over: '',
    not_over: '',
    ordinance_revision_id: ordinanceRevisionId,
  });

  const validateForm = useFormValidator(formData, {
    assessment_level: 'required',
    rptax_land_classification_id: 'required',
    over: 'required',
    not_over: 'required',
    ordinance_revision_id: 'required',
  });

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const setModal = useContext(ModalContext);

  const [landClass, setLandClass] = useState({
    label: '',
    value: 0,
  })

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (type === 'NEW') {
      createData(omitEmptyArgs(formData), (data) => {
        setModal({ isOpen: false });
        getList({
          isPaginate: 1,
          ordinance_revision_id: ordinanceRevisionId
        });
        history.push(
          `/rpt/building/settings/assessment-levels/${data.data.id}`
        );
        showData(data.data.id, ordinanceRevisionId);
      });
    }

    if (type === 'EDIT') {
      updateData(dataInfo.id, omitEmptyArgs(formData), (data) => {
        setModal({ isOpen: false });
        getList({
          isPaginate: 1,
          ordinance_revision_id: ordinanceRevisionId
        });
        history.push(
          `/rpt/building/settings/assessment-levels/${data.data.id}`
        );
        showData(data.data.id, ordinanceRevisionId);
      });
    }

  };

  const handleOnClose = (e) => {
    if (e) e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    if (type === "EDIT") {
      setFormData({
        ...formData,
        assessment_level: _.get(dataInfo, 'assessment_level'),
        over: _.get(dataInfo, 'over'),
        not_over: _.get(dataInfo, 'not_over'),
        rptax_land_classification_id: _.get(dataInfo, 'rptax_land_classification_id'),
        ordinance_revision_id: _.get(dataInfo, 'ordinance_revision_id'),
      });
    }
  }, []);

  const createDropdownLandClass = list => {
    const newList = [];
    list.map(data => {
      return newList.push({
        label: data.attributes.name,
        value: data.id,
      });
    });
    return newList;
  };

  const handleLandClassSelect = e => {
    setLandClass(e);
    setFormData({
      ...formData,
      rptax_land_classification_id: e.value,
    });
  };

  useEffect(() => {
    getLandClassificationsList();

    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  useEffect(() => {
    if (_.isEmpty(ordinanceRevisionList)) getOrdinanceRevisionList();
  }, []);

  const createDropdown = (list) => {
    const newList = [];
    list.map((data) => {
      return newList.push({
        name: data.attributes.name,
        year_from: data.attributes.year_from,
        year_to: data.attributes.year_to,
        value: data.id,
      });
    });
    return newList;
  };

  const onRenderOption = (item) => {
    return (
      <table>
        <tbody>
          <tr>
            <td style={{ width: 250 }}>{item.name}</td>
            <td className="text-right" style={{ width: 100 }}>
              {item.year_from} - {item.year_to}{' '}
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  const handleOrdinanceSelect = (e) => {
    setFormData({
      ...formData,
      ordinance_revision_id: e.value,
    });
  };

  const onChange = (e) => {
    const isChecked = e.target.checked ? 1 : 0;
    setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? isChecked : e.target.value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className='row'>
          {type === 'NEW' && (
            <div className="col-12 form-group">
              <label className="form-label">Land Classification{' '}
                {validateForm.renderMessage('rptax_land_classification_id')}
              </label>
              <div>
                <Select
                  options={createDropdownLandClass(landClassificationsList)}
                  styles={customStyle}
                  placeholder="Select Land Classification"
                  value={landClass}
                  onChange={e => {
                    handleLandClassSelect(e);
                  }}
                />
              </div>
            </div>
          )}
          <div className='col-12 form-group'>
            <label htmlFor="last_name" className="form-label mb-0">
              Assessment Level{' '}
              {validateForm.renderMessage('assessment_level')}
            </label>
            <input
              className="form-control"
              type="number"
              name="assessment_level"
              onChange={onChange}
              value={_.get(formData, 'assessment_level')}
            />
          </div>
          <div className='col-12 form-group'>
            <label htmlFor="last_name" className="form-label mb-0">
              Over{' '}
              {validateForm.renderMessage('over')}
            </label>
            <input
              className="form-control"
              type="number"
              name="over"
              onChange={onChange}
              value={_.get(formData, 'over')}
            />
          </div>
          <div className='col-12 form-group'>
            <label htmlFor="last_name" className="form-label mb-0">
              Not Over{' '}
              {validateForm.renderMessage('not_over')}
            </label>
            <input
              className="form-control"
              type="number"
              name="not_over"
              onChange={onChange}
              value={_.get(formData, 'not_over')}
            />
          </div>
          <div className='col-12 form-group'>
            <label htmlFor="last_name" className="form-label mb-0">
              Ordinance Revision{' '}
              {validateForm.renderMessage('ordinance_revision_id')}
            </label>
            <Select
              options={createDropdown(ordinanceRevisionList)}
              styles={customStyle}
              placeholder="Select Ordinance"
              isDisabled
              value={
                createDropdown(ordinanceRevisionList).filter(
                  (item) =>
                    +_.get(formData, 'ordinance_revision_id') ===
                    +_.get(item, 'value')
                ) || ''
              }
              onChange={(e) => {
                handleOrdinanceSelect(e);
              }}
              formatOptionLabel={onRenderOption}
            />
          </div>
        </div>
        <div className='d-flex justify-content-center mt-4'>
          <button
            disabled={!validateForm.response.is_passed}
            type='submit'
            className='btn btn-md btn-primary cms-bg-color-primary cms-outline-primary mr-1 cms-bg-color-primary'
          >
            Submit
          </button>
          <button
            type='button'
            onClick={handleOnClose}
            className='btn btn-light ml-1'
          >
            Cancel
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

AssessmentLevelsModal.defaultProps = {
  type: '',
  dataInfo: {},
  ordinanceRevisionId: ''
};

AssessmentLevelsModal.propTypes = {
  createData: PropTypes.instanceOf(Function).isRequired,
  updateData: PropTypes.instanceOf(Function).isRequired,
  type: PropTypes.string,
  ordinanceRevisionId: PropTypes.string,
  dataInfo: PropTypes.instanceOf(Object),
  getList: PropTypes.instanceOf(Function).isRequired,
  showData: PropTypes.instanceOf(Function).isRequired,
  getLandClassificationsList: PropTypes.instanceOf(Function).isRequired,
  landClassificationsList: PropTypes.instanceOf(Array).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getOrdinanceRevisionList: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  landClassificationsList: _.get(api, `${c.GET_LAND_CLASSIFICATIONS}.list`) || [],
  ordinanceRevisionList: _.get(api, `${c.GET_ORDINANCE_REVISION_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withRouter,
  withForm,
  connect(mapStateToProps, actions),
]);

export default enhance(AssessmentLevelsModal);
